import React from 'react';
import { Drawer, Timeline, Typography } from 'antd';
import { drawerWidth } from '../../utils/constants';
import { handleAnomalyDateConvertDayJs } from '../../utils/functions';

const {Text} = Typography;

const DocumentAnomaliesHistory = ({ open, onClose, anomalies }) => {

   
    return (
        <Drawer
            title="Anomalie"
            width={drawerWidth}
            onClose={onClose}
            destroyOnClose={true}
            open={open}
        >
            <Timeline>
                {anomalies.map((anomaly, index) => (
                    <Timeline.Item 
                    color={"#c11919"}
                    key={index}
                    >
                        {index === 0 && (
                            <Text strong style={{color: "#c11919"}}>[{handleAnomalyDateConvertDayJs(anomaly.operationDate)}] {anomaly.anomalyName}</Text>
                        )}

                        {index !== 0 && (
                            <Text>[{handleAnomalyDateConvertDayJs(anomaly.operationDate)}] {anomaly.anomalyName}</Text>
                        )}                        
                    
                    </Timeline.Item>
                ))}
            </Timeline>
           
        </Drawer>
    );
}
export default DocumentAnomaliesHistory;